import { FC, InputHTMLAttributes } from 'react';
import { cn } from '../../../utils/helpers';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  inputClassname?: string;
  error?: string;
}

const Input: FC<Props> = ({ name, label, value, className, inputClassname, type, error, ...rest }) => {
  return (
    <div className={cn('relative', error && 'mb-2', className)}>
      <label
        htmlFor={name}
        className={cn(
          'absolute',
          'transition-all duration-100',
          'cursor-text',
          !value && value !== 0 && type !== 'date'
            ? 'top-1/2 transform -translate-y-1/2 text-sm left-4 text-content'
            : 'top-[-7px] bg-white text-xs px-1 left-3 text-raisin-black',
        )}
      >
        {label}
      </label>
      <input
        id={name}
        className={cn(
          'w-full',
          'outline-none border',
          error ? 'border-negative' : 'border-[#DADADA]',
          'rounded p-4 text-sm max-h-[52px]',
          'disabled:bg-white',
          inputClassname,
        )}
        name={name}
        defaultValue={value}
        type={type}
        {...rest}
      />
      {error && <p className={cn('text-sm text-negative', 'absolute bottom-[-20px]')}>{error}</p>}
    </div>
  );
};

export default Input;
